/** Dependency-free site identity, shared by app code and build scripts. */
export const SITE_URL = "https://lezo.dev";
export const SITE_NAME = "Lezo";
